import React from 'react';
import { motion } from 'framer-motion';
import { YouTubeEmbed } from './YouTubeEmbed';
export function VideoSection() {
  return <section className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-409" data-mp="18vrup43wj8ux">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-410" data-mp="1nsivnht84smn" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-411" data-mp="1iso3zc1mjz0j" />
      <div className="relative z-10 mx-auto max-w-[1100px]" data-id="element-412" data-mp="1ir3dbxifl07y">
        <div className="mb-10" data-id="element-413" data-mp="1wr4bv6b83vk9">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5
        }} className="font-heading text-4xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-5xl" style={{
          fontSize: "36px"
        }} data-id="element-414" data-mp="1wqct4w2q5sbe">
            Ein Einblick in unsere{' '}
            <span className="block text-hot-500" style={{
            fontSize: "36px"
          }} data-id="element-415" data-mp="2fi5kyn6257hj">Sales Mastermind</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="mt-6 text-sm leading-relaxed text-neutral-600 sm:text-base" data-id="element-416" data-mp="2bid65sq2m53q">
            <span className="block" data-id="element-417" data-mp="13t1zwyikgkkw">
              Stell dir vor, du kannst von überall auf der Welt arbeiten – mit nichts weiter als
              deinem Smartphone und einer Internetverbindung. Dein Kalender füllt sich mit
              vorqualifizierten Interessenten, mit denen du deine Gespräche führst.
            </span>
            <span className="mt-3 block" data-id="element-418" data-mp="1mkutov5gm9to">
              Dein einziger Job – Du führst Gespräche authentisch und auf Augenhöhe und
              entscheidest selbst, von wo aus du arbeitest: am Pool, auf dem Sofa oder von deinem
              Lieblingsort irgendwo auf der Welt.
            </span>
            <span className="mt-3 block" data-id="element-419" data-mp="21i537yyjl5mr">
              Das ist mehr als nur Sales. Unsere Sales Mastermind in Dubai zeigt, was entsteht, wenn
              ambitionierte Frauen mit großen Zielen zusammenkommen: neue Verbindungen, neue
              Perspektiven, Wachstum und Momente, die bleiben. Ein Einblick in die Welt der Hot
              Sales Girls – und in das, was möglich wird, wenn du dich für mehr entscheidest.
            </span>
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative aspect-video w-full overflow-hidden rounded-3xl shadow-2xl" data-id="element-420" data-mp="1gqzu5dh60u0m">
          <YouTubeEmbed videoId="3Zg3k9r6lNQ" title="Ein Einblick in unsere Sales Mastermind in Dubai – Hot Sales Girls Academy" data-id="element-421" data-mp="1zjtzrgswf9s6" />
        </motion.div>
      </div>
    </section>;
}